import { Skeleton } from './skeleton';

export function SkeletonOrderCard({ testid = 'skeleton-order-card' }) {
  return (
    <div data-testid={testid} className="bg-[var(--bg-L1)] border border-[var(--border-default)] rounded-2xl p-3">
      <div className="flex items-center gap-3">
        <div className="flex-1 min-w-0">
          <div className="flex items-center justify-between gap-2 mb-1">
            <Skeleton className="h-5 w-32 rounded" />
            <Skeleton className="h-6 w-20 rounded-full" />
          </div>
          <Skeleton className="h-4 w-40 rounded" />
        </div>
      </div>
    </div>
  );
}
